<template>
  <div
    :class="{'m-0': noMargin}"
    class="form-group">
    <label
      :for="id"
      class="sr-only"/>
    <div class="form-control-container">
      <textarea
        ref="input"
        :name="id"
        :id="id"
        :key="id"
        :class="inputClass"
        :placeholder="label"
        :data-vv-as="label.toLowerCase()"
        :value="value"
        :disabled="disabled"
        class="form-control"
        @input="updateValue($event.target.value)"
      />
      <!-- v-validate="validate" -->
      <div class="form-control-validation is-invalid">
        <i
          v-b-tooltip.topleft.click.hover
          :title="errors.first(`${form}.${id}`)"
          class="material-icons d-flex align-items-center h-100">error_outline</i>
        <div
          class="tooltip bs-tooltip-top show d-none"
          role="tooltip"
          tabindex="-1"
          x-placement="top">
          <div class="arrow"/>
          <div class="tooltip-inner">{{ errors.first(`${form}.${id}`) }}</div>
        </div>
      </div>
      <div class="form-control-validation is-valid">
        <i class="material-icons d-flex align-items-center h-100">check</i>
      </div>
      <div
        v-if="isRequired"
        class="form-control-validation">
        <span class="d-flex align-items-center h-100">*</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import bTooltip from 'bootstrap-vue/es/directives/tooltip/tooltip';
import { getParentFormId, fieldReset } from '@/helpers/forms';
import { generateId } from '@/helpers/components';

export default {
  inject: ['$validator'],
  directives: {
    bTooltip,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    validate: {
      type: String,
      default: '',
    },
    inputClass: {
      type: String,
      default: '',
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: '',
      id: generateId(),
    };
  },
  computed: {
    isRequired() {
      return this.validate.indexOf('required') !== -1;
    },
    ...mapState('app', ['isFormReset']),
  },
  watch: {
    isFormReset() {
      fieldReset(this.$refs.input);
    },
  },
  mounted() {
    this.form = getParentFormId(this);
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/styles/_includes.scss";

.form-control-container {
  position: relative;

  .form-control {
    ~ .form-control-validation.is-valid,
    ~ .form-control-validation.is-invalid {
      display: none;
    }

    &.is-valid,
    &.is-invalid {
      border-color: $input-border-color;
    }
  }

  .form-control.is-valid ~ .form-control-validation.is-valid,
  .form-control.is-invalid ~ .form-control-validation.is-invalid {
    display: block;

    ~ .form-control-validation {
      display: none;
    }
  }

  .form-control-validation {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;

    i,
    span {
      padding-left: map-get($spacers, 2);
      padding-right: map-get($spacers, 2);
      font-size: 30px;
    }

    .tooltip {
      position: absolute;
      bottom: calc(100% + 0.25rem);
      right: 0;
      width: 200px;

      .arrow {
        right: 1rem;
      }
    }

    &.is-valid {
      color: $success;
    }

    &.is-invalid {
      color: $danger;
    }
  }
}
</style>
